// Logging system is used from $2sxc API
/**
 * @internal
 */
export * from '../../../core';
